var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvalid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.702945 4.09706C-0.234315 3.1598 -0.234315 1.6402 0.702945 0.702944C1.6402 -0.234315 3.1598 -0.234315 4.09706 0.702944L10.5 7.10589L16.9029 0.702944C17.8402 -0.234315 19.3598 -0.234315 20.2971 0.702944C21.2343 1.6402 21.2343 3.1598 20.2971 4.09706L13.8941 10.5L20.2971 16.9029C21.2343 17.8402 21.2343 19.3598 20.2971 20.2971C19.3598 21.2343 17.8402 21.2343 16.9029 20.2971L10.5 13.8941L4.09706 20.2971C3.1598 21.2343 1.6402 21.2343 0.702945 20.2971C-0.234314 19.3598 -0.234314 17.8402 0.702945 16.9029L7.10589 10.5L0.702945 4.09706Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalid);
export default __webpack_public_path__ + "static/media/invalid.afcbe4bf7ca924299ac7ef0f470bce2c.svg";
export { ForwardRef as ReactComponent };